import { render, staticRenderFns } from "./DxPlanningComponent.vue?vue&type=template&id=7f5f66dc&scoped=true&"
import script from "./DxPlanningComponent.vue?vue&type=script&lang=js&"
export * from "./DxPlanningComponent.vue?vue&type=script&lang=js&"
import style0 from "./DxPlanningComponent.vue?vue&type=style&index=0&id=7f5f66dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5f66dc",
  null
  
)

export default component.exports